import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Message} from "primeng/primeng";
import {Producto} from "./producto";
import {ProductoService} from "../Services/producto.service";
import {CategoriaService} from "../Services/categoria.service";
import {Categoria} from "../categoria/categroia";


@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.css']
})
export class ProductoComponent implements OnInit {

  msgs: Message[] = [];
  formProducto : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  tiposDocumento = [];
  panelRequeridos = false;
  loading = false;
  ProductosRegistrados:Producto[];
  ProductoSeleccionado:Producto;
  tipoGuardado = '';
  CategoriasRegistrados:Categoria[];


  constructor(private servicioCategoria:CategoriaService,private servicioProducto:ProductoService,private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesProducto();
    this.Cancelar();
    this.poblarTiposDoc();
    this.listarProductos();
    this.listarCategorias();
  }

  crearControlesProducto(){
    this.formProducto = this.fb.group({
      nombre:['',Validators.required],
      categoria_id:['',Validators.required],
      unidad:['',Validators.required],
      precioCompra:['',Validators.required],
      precioVenta:['',Validators.required],
      stockMinimo:['',Validators.required],
      stockMaximo:['',Validators.required],
      marca:['',Validators.required],
      estado:[''],
      codigoBarra:['0',Validators.required],
      dimension:[''],
      presentacion:[''],
      color:[''],
      fechaVencimiento:[''],
      impuesto:[''],
      ubicacion:[''],
      imagen:[''],
      talla:[''],

      }
    );

  }
  nuevoProducto(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formProducto.enable();
    this.formProducto.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formProducto.reset();
    this.formProducto.disable();
    this.panelRequeridos = false;
  }
  poblarTiposDoc(){
    this.tiposDocumento.push({label:'Seleccione un Tipo', value:''});
    this.tiposDocumento.push({label:'C.C', value:'C.C'});
    this.tiposDocumento.push({label:'PASAPORTE', value:''});
    this.tiposDocumento.push({label:'C.E.', value:''});
    this.tiposDocumento.push({label:'DNI', value:''});
    this.tiposDocumento.push({label:'NIT', value:''});
    this.tiposDocumento.push({label:'NUIP', value:''});
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoProducto(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioProducto.putProducto(this.formProducto.value,this.ProductoSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarProductos();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;

      this.servicioProducto.addProducto(this.formProducto.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarProductos();
            this.loading = false;
          },
          er => {
            this.mensajes('error','Error',er);
            this.loading = false;
          },
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarProductos(){
    this.loading = true;
    this.servicioProducto.getProducto()
      .subscribe(
        rt => {
          this.ProductosRegistrados = rt;

        },
        er => this.mensajes('error','Error',er),
        () =>  {
          this.loading = false;
        }
      );
  }
  seleccionarProducto(item:Producto){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formProducto.enable();
    this.panelRequeridos = true;
    this.ProductoSeleccionado = item;
    this.ProductoDetalle(item);
    this.tipoGuardado = 'editar';
  }
  ProductoDetalle(item:Producto):void {
    this.formProducto.patchValue({
      id:item.id,
      nombre:item.nombre,
      precioCompra:item.precioCompra,
      precioVenta:item.precioVenta,
      estado:item.estado,
      codigoBarra:item.codigoBarra,
      dimension:item.dimension,
      presentacion:item.presentacion,
      color:item.color,
      fechaVencimiento:item.fechaVencimiento,
      impuesto:item.impuesto,
      stockMinimo:item.stockMinimo,
      stockMaximo:item.stockMaximo,
      ubicacion:item.ubicacion,
      categoria_id:item.categoria_id,
      unidad:item.unidad,
      Proveedor_id:item.Proveedor_id,
      imagen:item.imagen,
      talla:item.talla,
      marca:item.marca

    });
  }
  listarCategorias(){
    this.loading = true;
    this.servicioCategoria.getCategoria()
      .subscribe(
        rt => {
          this.CategoriasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }

}




// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/producto/producto.component.ts